import { ColumnsType } from "antd/es/table";
import React from "react";
import NameLink from "../../Template/NameLink";
import IsDataNull from "../../Template/IsDataNull";
import { Tooltip } from "antd";
import { PackType } from "../../../utils/type";
import { DownOutlined, LockOutlined, UnlockOutlined, UpOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import IconsandOrganization from "../ActionButtons/IconsandOrganization";
import SortIcon from "./SortIcon";

const TableColumn: ColumnsType<PackType> = [
  {
    title: "Organization",
    key: "tenantName",
    dataIndex: "tenantName",
    sorter: true,
    render: (data, record) => (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <IconsandOrganization lockedUserEmail={record.lockedUserEmail} />
        <IsDataNull data={data} />
      </div>
    ),
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    width: 200,
    fixed: "right",
  },
  {
    title: "Requestor ",
    key: "clientName",
    dataIndex: "clientName",
    sorter: true,
    render: (data) => <IsDataNull data={data} />,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    width: 150,
    fixed: "right",
  },
  {
    title: "File Name",
    key: "fileName",
    dataIndex: "fileName",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },

    render: (data, record) => {
      const maxLength = 30;
      const shortenedName = data.length > maxLength ? data.substring(0, maxLength) + "..." : data;

      return (
        <Tooltip
          title={data}
          placement="top">
          <span>
            <NameLink<PackType>
              name={shortenedName}
              disabled={!(record.status === "QC_READY" || record.status === "QC_IN_PROGRESS" || record.status === "ARCHIVED" || record.status === "QC_COMPLETE")}
              record={record}
              navigateTo={`/auth/pack/${record.packId}`}
            />
          </span>
        </Tooltip>
      );
    },
    width: 200,
    fixed: "right",
  },
  {
    title: "Priority",
    key: "priority",
    dataIndex: "priority",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data) => <IsDataNull data={data} />,
    width: 50,
    fixed: "right",
  },
  {
    title: "Type",
    key: "transcriptionType",
    dataIndex: "transcriptionType",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data) => <IsDataNull data={data} />,
    width: 70,
    fixed: "right",
  },

  {
    title: "Status",
    key: "status",
    dataIndex: "status",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data, record) => <IsDataNull data={record.statusLabel} />,
    width: 100,
    fixed: "right",
  },
  {
    title: "Created Date",
    key: "createdDate",
    dataIndex: "createdDate",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data) => <IsDataNull data={data} />,
    width: 100,
    fixed: "right",
  },
  {
    title: "Error",
    key: "errorReason",
    dataIndex: "errorReason",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data) => {
      if (!data) return "-"; // Handle null or undefined values

      const maxLength = 20;
      const shortenedText = data.length > maxLength ? data.substring(0, maxLength) + "..." : data;

      return (
        <Tooltip
          title={data}
          placement="top">
          <span style={{ color: "#CC0000" }}>{shortenedText}</span>
        </Tooltip>
      );
    },
    width: 200,
    fixed: "right",
  },
];

export default TableColumn;
